import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = "https://oztrzdlqjnnhfuijvkzk.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_o1v3f-vqfEedkHxzAOcYAg_nE-jIjrN";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "nexa-scales-auth"
  },
  global: {
    headers: { "x-client-info": "nexa-scales-web" }
  }
});

export async function submitEnquiry(values) {
  const record = {
    enquiry_type: "Project enquiry",
    name: clean(values.name, 160),
    business_name: clean(values.business_name, 160),
    email: clean(values.email, 254)?.toLowerCase(),
    phone: clean(values.phone, 80),
    service: clean(values.service, 160),
    budget: clean(values.budget, 80),
    message: clean(values.message, 4000),
    status: "New"
  };
  if (!record.name || !record.email || !record.message) throw new Error("Name, email and project details are required.");
  const { data, error } = await supabase.from("enquiries").insert(record).select("id").single();
  if (error) throw new Error("Your enquiry could not be sent. Please use WhatsApp instead.");
  return data;
}

function clean(value, max) {
  const text = String(value ?? "").trim();
  return text ? text.slice(0, max) : null;
}
